export default "__VITE_ASSET__eUTkT3SD__"